/**
 * Service for the login page commercial content (multilingual).
 */
import useApi from '../utils/api';

class LoginPageContentService {
  #prefix = '/loginPageContent';

  list = () => {
    return useApi.get(this.#prefix);
  };

  create = (data) => {
    return useApi.post(this.#prefix, data);
  };

  update = (id, data) => {
    return useApi.put(`${this.#prefix}/${id}`, data);
  };

  remove = (id) => {
    return useApi.delete(`${this.#prefix}/${id}`);
  };
}

export default new LoginPageContentService();
